// extracted by mini-css-extract-plugin
export default {"BackButton":"Backbutton_BackButton__A83IZ"};